import Colors from 'assets/Colors';
import UIConst from 'consts/UIConst';
import React from 'react';
import { ActivityIndicator, StyleSheet, TextInput, View } from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import BaseButton from './BaseButton';

export default class SimpleInput extends React.PureComponent {
  static defaultProps = {
    multiline: false,
    showClear: false,
    inputStyle: {},
    style: {},
    hasSearchIcon: false,
    childComponent: null
  };

  constructor(props) {
    super(props);
    this.state = { value: '', searching: false, canShowClear: false };
    this.value = '';
  }

  focus = () => {
    this.input?.focus?.();
  };

  reset = () => {
    this.setText('');
  };

  getText = () => {
    return this.value;
  };

  setText = (value, callback) => {
    if (!value) value = '';
    value = value.toString();
    this.value = value;
    const { showClear } = this.props;
    this.setState(
      {
        value,
        ...(showClear ? { canShowClear: value.length > 0 } : null)
      },
      () => {
        callback?.();
      }
    );
  };

  onChangeText = (value) => {
    this.value = value;
    const { onChangeText, showClear } = this.props;
    this.setState({ value, ...(showClear ? { canShowClear: value?.toString()?.length > 0 } : null) });
    if (onChangeText) onChangeText(value);
  };

  onPressClear = () => {
    this.setText('');
    const { onChangeText } = this.props;
    if (onChangeText) onChangeText('');
  };

  render() {
    const { showClear, inputStyle, style, hasSearchIcon, childComponent, fontSize = UIConst.FONT_SIZE, multiline } = this.props;
    const { searching, canShowClear, value } = this.state;
    const multilineStyle = multiline ? { height: '100%' } : {};

    return (
      <View style={[{ backgroundColor: Colors.box }, style, { alignItems: 'center', flexDirection: 'row', paddingRight: UIConst.SCALE * 5 }]}>
        {!!hasSearchIcon && <MaterialIcons name={'search'} size={UIConst.SCALE * 18} color={Colors.text} style={{ marginLeft: UIConst.SCALE * 6, opacity: 0.5 }} />}
        <TextInput
          {...this.props}
          ref={(input) => (this.input = input)}
          value={value}
          onChangeText={this.onChangeText}
          style={[styles.textInputStyle, { color: Colors.text, fontSize }, multilineStyle, inputStyle]}
          placeholderTextColor={Colors.placeholder}
          textAlignVertical={multiline ? 'top' : 'center'}
        />
        {!!searching && <ActivityIndicator size={'small'} style={{}} />}
        {!!showClear && !searching && canShowClear && (
          <BaseButton style={{}} onPress={this.onPressClear}>
            <MaterialCommunityIcons name={'close-circle'} size={UIConst.SCALE * 18} color={Colors.text} />
          </BaseButton>
        )}
        {childComponent}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  textInputStyle: {
    flex: 1,
    fontSize: UIConst.FONT_SIZE,
    paddingVertical: UIConst.SCALE * 6,
    paddingHorizontal: UIConst.SCALE * 7
  }
});
